/*!
 * contentloaded.js
 *
 * Author: Diego Perini (diego.perini at gmail.com)
 * Summary: cross-browser wrapper for DOMContentLoaded
 * Updated: 20101020
 * License: MIT
 * Version: 1.2
 *
 * URL:
 * http://javascript.nwbox.com/ContentLoaded/
 * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
 *
 */

// @win window reference
// @fn function reference
const pageReady = (win, fn) => {
  let done = false,
    top = true;
  const doc = win.document,
    root = doc.documentElement,
    modern = doc.addEventListener,
    add = modern ? 'addEventListener' : 'attachEvent',
    rem = modern ? 'removeEventListener' : 'detachEvent',
    pre = modern ? '' : 'on';
  const init = function(e) {
    if (e.type === 'readystatechange' && doc.readyState !== 'complete') return;
    (e.type === 'load' ? win : doc)[rem](pre + e.type, init, false);
    if (!done && (done = true)) fn.call(win, e.type || e);
  };
  const poll = function() {
    try {
      root.doScroll('left');
    } catch (e) {
      setTimeout(poll, 50);
      return;
    }
    init('poll');
  };

  if (doc.readyState === 'complete') fn.call(win, 'lazy');
  else {
    if (!modern && root.doScroll) {
      try {
        top = !win.frameElement;
            } catch (e) { } //eslint-disable-line
      if (top) poll();
    }
    doc[add](`${pre}DOMContentLoaded`, init, false);
    doc[add](`${pre}readystatechange`, init, false);
    win[add](`${pre}load`, init, false);
  }
};

const pageLoad = (win, fn) => win.addEventListener('load', fn);

module.exports = { pageLoad, pageReady };
